export default {
  apiHost: 'https://api.fun100.kr',
}
